import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  fetchContentV2TrendingHashtagsApiLimit,
} from '../../services/rtdb-service';

const fetchContentV2TrendingHashtagsByLanguage = () => {
  const [ trendingHashtagsApiLimitData, setTrendingHashtagsApiLimitData ] = useState({ });
  const [ fetchData, setFetchData ] = useState(null);
  const {
    onOperationComplete,
  } = fetchData || {};

  const fetchTrendingHashtagsApiLimit = async () => {
    try {
      console.log(`Fetching trending hashtags API limit from RTDB`);
      setTrendingHashtagsApiLimitData({
        isFetching: true,
        isError: false,
      });

      const trendingHashtagsApiResp =  await fetchContentV2TrendingHashtagsApiLimit();
      console.log(`Fetching trending hashtags API limit from RTDB is Success!!`);

      let errorMsg = null;

      setTrendingHashtagsApiLimitData({
        data: trendingHashtagsApiResp,
        isFetching: false,
        isError: false,
        errorMsg,
      });

      if(onOperationComplete) {
        onOperationComplete({
          data: trendingHashtagsApiResp,
          isError: false,
          errorMsg,
        });
      }
    } catch (err) {
      console.log(`Error while fetching trending hashtags  API limit from RTDB Error : ${err}`);
      const errorMsg = `Error occurred while fetching hashtags API limit from RTDB.`;
      setTrendingHashtagsApiLimitData({
        data: null,
        isFetching: false,
        isError: true,
        errorMsg,
      });
      if(onOperationComplete) {
        onOperationComplete({
          data: null,
          isError: true,
          errorMsg,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(fetchData)) {
      fetchTrendingHashtagsApiLimit();
    }
  }, [ fetchData ]);

  return [
    trendingHashtagsApiLimitData,
    setFetchData,
  ];
};

export default fetchContentV2TrendingHashtagsByLanguage;
